import { createSlice } from '@reduxjs/toolkit'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Level } from '../components/partners'
import { getLevelList, GetLevelListRequest } from '../api/level'

export type LevelListState = {
   isPristine: boolean
   isFetching: boolean
   items: Array<Level>
   totalSize: number
}

const initialState: LevelListState = {
   isPristine: true,
   isFetching: false,
   items: [],
   totalSize: 0,
}

export const getLevelListThunk = createAsyncThunk(
   'getLevelList',
   async (request: GetLevelListRequest | undefined, { rejectWithValue }) => {
      try {
         return await getLevelList(request)
      } catch {
         return rejectWithValue(null)
      }
   },
)

export const levelListSlice = createSlice({
   name: 'levelListSlice',
   initialState,
   reducers: {
      clear: () => {
         return initialState
      },
   },
   extraReducers(builder) {
      builder.addCase(getLevelListThunk.pending, (state) => {
         state.isPristine = false
         state.isFetching = true
      })
      builder.addCase(getLevelListThunk.fulfilled, (state, action) => {
         const { payload } = action
         state.isPristine = false
         state.isFetching = false
         state.items = payload.items
         state.totalSize = payload.totalSize
      })
      builder.addCase(getLevelListThunk.rejected, (state) => {
         state.isPristine = false
         state.isFetching = false
      })
   },
})

export const { clear } = levelListSlice.actions

export default levelListSlice.reducer
